export default __webpack_public_path__ + "static/media/academic-advisor.d0c61d33.svg";